import { useLayoutEffect } from 'react';

const SCROLLBAR_CLASSES = [
  'scrollbar-thin',
  'scrollbar-thumb-rounded-full',
  'scrollbar-thumb-baltic-sea',
  'scrollbar-track-transparent',
  'hover:scrollbar-thumb-mantis',
  'active:scrollbar-thumb-kiwi-green'
];

export const useTailwindScrollbar = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.add(...SCROLLBAR_CLASSES);

    return () => {
      document.documentElement.classList.remove(...SCROLLBAR_CLASSES);
    };
  }, []);
};
